/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Roles_User_First_NameInputs */

const en_tables_roles_user_first_name = /** @type {(inputs: Tables_Roles_User_First_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User First Name`)
};

const de_tables_roles_user_first_name = /** @type {(inputs: Tables_Roles_User_First_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer Vorname`)
};

/**
* | output |
* | --- |
* | "User First Name" |
*
* @param {Tables_Roles_User_First_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_roles_user_first_name = /** @type {((inputs?: Tables_Roles_User_First_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Roles_User_First_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_roles_user_first_name(inputs)
	return de_tables_roles_user_first_name(inputs)
});